import enTranslations from "./en.translations.json"
import frTranslations from "./fr.translations.json"
import nlTranslations from "./nl.translations.json"

export enum Locales {
  EN = "en",
  NL = "nl",
  FR = "fr",
}

const locales = [Locales.EN, Locales.NL, Locales.FR]

const translations = {
  [Locales.EN]: {
    ...enTranslations,
  },
  [Locales.NL]: {
    ...nlTranslations,
  },
  [Locales.FR]: {
    ...frTranslations,
  },
}

const formats = {}

export { locales, translations, formats }
